import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ButtonToolbar } from 'reactstrap';
import PropTypes from 'prop-types';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import {
  NEW_AGENCY_INCIDENT_PATH,
  AGENCY_INCIDENT_PATH,
} from '../../../../config/paths';
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { AGENCY_INCIDENTS_COLUMNS } from '../../../../config/columns';
import {
  clearAgencyIncidents,
  getAgencyIncidents,
} from '../../../../actions/supervision-control/AgencyIncident';
import IncidentsSearchForm from './IncidentsSearchForm';

const AgencyIncidents = ({
  breadcrumbs,
  dispatchGetAgencyIncidents,
  dispatchClearAgencyIncidents,
  loading,
  agencyIncidents,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearAgencyIncidents();
    },
    [],
  );

  const onSubmit = (formValues) => {
    const newFormValues = {
      dateString: tzNormalizeDate({
        date: formValues.dateString,
        format: INT_DATE_FORMAT,
      }),
      agencyId: formValues.agency ? formValues.agency.value : null,
    };
    dispatchGetAgencyIncidents(newFormValues);
  };

  const content = (
    <>
      <IncidentsSearchForm
        onSubmit={onSubmit}
        initialValues={{
          dateString: tzNormalizeDate(),
        }}
        loading={loading}
      />
      <Table
        data={agencyIncidents}
        columns={AGENCY_INCIDENTS_COLUMNS}
        manual={false}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        loading={loading}
        filterable
        navigateToModelOnRowClick
        isExternalPath
        modelPath={AGENCY_INCIDENT_PATH}
      />
    </>
  );

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <div>
        <Link
          to={NEW_AGENCY_INCIDENT_PATH}
          className="btn btn-primary pull-right"
        >
          <i className="fa fa-plus-circle" /> Crear
        </Link>
      </div>
    </ButtonToolbar>
  );

  return (
    <Content
      title="Incidentes de Agencia"
      content={content}
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
    />
  );
};

AgencyIncidents.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetAgencyIncidents: PropTypes.func.isRequired,
  dispatchClearAgencyIncidents: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  agencyIncidents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      date: PropTypes.string,
      time: PropTypes.string,
      agency: PropTypes.string,
      note: PropTypes.string,
    }),
  ).isRequired,
};

AgencyIncidents.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Incidentes de Agencia',
      href: '',
    },
  ],
  loading: SupervisionControlUnit.AgencyIncident.getIn([
    'agencyIncidents',
    'loading',
  ]),
  agencyIncidents: SupervisionControlUnit.AgencyIncident.getIn([
    'agencyIncidents',
    'content',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchGetAgencyIncidents: getAgencyIncidents,
  dispatchClearAgencyIncidents: clearAgencyIncidents,
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyIncidents);
